import { ExamType } from '../matura/common';
import { ExamAnswerKey } from './types';
import dwujezycznaMedia2026 from './keys/dwujezyczna-media-spolecznosciowe-2026.json';
import e8Media2026 from './keys/e8-media-spolecznosciowe-2026.json';
import podstawaMedia2026 from './keys/podstawa-media-spolecznosciowe-2026.json';
import rozszerzenieMedia2026 from './keys/rozszerzenie-media-spolecznosciowe-2026.json';
import rozszerzenieWalentynki2026 from './keys/rozszerzenie-walentynki-2026.json';
import rozszerzenieWielkanoc2026 from './keys/rozszerzenie-wielkanoc-2026.json';
import e8Halloween2026 from './keys/e8-halloween-2026.json';
import podstawaHalloween2026 from './keys/podstawa-halloween-2026.json';
import rozszerzenieHalloween2026 from './keys/rozszerzenie-halloween-2026.json';
import dwujezycznaHalloween2026 from './keys/dwujezyczna-halloween-2026.json';

export * from './types';

/**
 * Every exam sheet Classovo can score automatically, keyed by `ExamAnswerKey.id`.
 *
 * Exams are authored by us and shipped as code, so adding a sheet means adding a
 * key file here — there is no database collection and no admin UI.
 */
export const EXAM_ANSWER_KEYS: Record<string, ExamAnswerKey> = [
  e8Halloween2026,
  podstawaHalloween2026,
  rozszerzenieHalloween2026,
  dwujezycznaHalloween2026,
  podstawaMedia2026,
  rozszerzenieMedia2026,
  dwujezycznaMedia2026,
  e8Media2026,
  rozszerzenieWalentynki2026,
  rozszerzenieWielkanoc2026,
].reduce<Record<string, ExamAnswerKey>>((acc, key) => {
  acc[key.id] = key as ExamAnswerKey;
  return acc;
}, {});

/** Returns undefined for an unknown id — callers surface that as a not-found error. */
export function getExamAnswerKey(id: string): ExamAnswerKey | undefined {
  return EXAM_ANSWER_KEYS[id];
}

export function listExamAnswerKeys(examType?: ExamType): ExamAnswerKey[] {
  const keys = Object.values(EXAM_ANSWER_KEYS);

  return examType ? keys.filter((key) => key.examType === examType) : keys;
}
